import { MenuItemType, BaseItem } from '../../../components/PaginatedTable/PaginatedTable.types';
import { AIResponse, ISourceDocument } from '../../../types';

export const mergeDynamicSuggestions = (
  oldSuggestions: AIResponse | undefined,
  newSuggestions: AIResponse | undefined,
): AIResponse => {
  if (!oldSuggestions && !newSuggestions) return {};
  if (!oldSuggestions) return { ...newSuggestions };
  if (!newSuggestions) return { ...oldSuggestions };

  const mergedState: AIResponse = { ...oldSuggestions };

  Object.keys(newSuggestions).forEach((key) => {
    if (oldSuggestions[key]) {
      mergedState[key] = [...mergedState[key], ...newSuggestions[key]];
    } else {
      mergedState[key] = newSuggestions[key];
    }
  });

  return mergedState;
};

export const getSourceDocumentsMenuItems = (
  handleViewClick: (row: { id: number }) => void,
): MenuItemType<ISourceDocument & BaseItem>[] => [
  {
    title: 'View',
    onClick: (id, row) => {
      handleViewClick(row?.original);
    },
  },
];
